document.addEventListener("DOMContentLoaded", function() {
  const accordion = document.querySelector('.bodyplanet-product-accordion .bp-accordion-container');
  if (!accordion) return;
  
  const headers = accordion.querySelectorAll('.bp-accordion-header');

  // Erstes Accordion automatisch öffnen
  if (headers.length > 0) {
    const firstItem = headers[0].closest('.bp-accordion-item');
    if (firstItem && !firstItem.classList.contains('bp-active')) {
      firstItem.classList.add('bp-active');
      headers[0].setAttribute('aria-expanded', 'true');
    }
  }

  // Accordion Event Listeners
  headers.forEach(header => {
    header.setAttribute('tabindex', '0');
    header.setAttribute('role', 'button');
    header.setAttribute('aria-expanded', header.closest('.bp-accordion-item').classList.contains('bp-active') ? 'true' : 'false');

    header.addEventListener('click', function() {
      const item = this.closest('.bp-accordion-item');
      const isActive = item.classList.contains('bp-active');

      // Alle Accordions zuklappen
      accordion.querySelectorAll('.bp-accordion-item').forEach(i => {
        i.classList.remove('bp-active');
        i.querySelector('.bp-accordion-header').setAttribute('aria-expanded', 'false');
      });

      // Aufklappen, wenn nicht aktiv
      if (!isActive) {
        item.classList.add('bp-active');
        this.setAttribute('aria-expanded', 'true');
        
        // Falls es das Nährwerte-Hub ist, initialisiere Tabs
        if (this.id === 'naehrwerte-hub') {
          initializeNutritionTabs();
        }
      }
    });

    // Keyboard Navigation
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Tab System für Nährwerte
  function initializeNutritionTabs() {
    const tabButtons = accordion.querySelectorAll('.bp-tab-btn');
    const tabContents = accordion.querySelectorAll('.bp-tab-content');
    
    if (!tabButtons.length) return;

    tabButtons.forEach(button => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', button.dataset.tab);
      
      button.addEventListener('click', function() {
        const targetTab = this.dataset.tab;
        
        // Remove active class from all buttons and contents
        tabButtons.forEach(btn => {
          btn.classList.remove('bp-active');
          btn.setAttribute('aria-selected', 'false');
        });
        tabContents.forEach(content => {
          content.classList.remove('bp-active');
          content.setAttribute('aria-hidden', 'true');
        });
        
        // Add active class to clicked button and corresponding content
        this.classList.add('bp-active');
        this.setAttribute('aria-selected', 'true');
        const targetContent = accordion.querySelector(`#${targetTab}`);
        if (targetContent) {
          targetContent.classList.add('bp-active');
          targetContent.setAttribute('aria-hidden', 'false');
        }
      });
      
      // Keyboard Navigation für Tabs
      button.addEventListener('keydown', function(e) {
        const tabs = Array.from(tabButtons);
        const currentIndex = tabs.indexOf(this);
        
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          const nextIndex = (currentIndex + 1) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          tabs[prevIndex].focus();
          tabs[prevIndex].click();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  // Initialize tabs if nutrition hub is already open
  const nutritionHub = accordion.querySelector('#naehrwerte-hub');
  if (nutritionHub && nutritionHub.closest('.bp-accordion-item').classList.contains('bp-active')) {
    initializeNutritionTabs();
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const OFFSET = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset')) || 100;
  const ACCORDION = document.getElementById('custom-accordion');
  const KEY = 'bp:' + '{{ product.id }}';

  function scrollToEl(el){ if(!el) return;
    const y = el.getBoundingClientRect().top + window.scrollY - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function openAccordionByHeaderId(id) {
    const header = document.getElementById(id);
    if (!header) return false;
    const item = header.closest('.bp-accordion-item');
    if (!item || !ACCORDION) return false;

    ACCORDION.querySelectorAll('.bp-accordion-item').forEach(i => {
      i.classList.remove('bp-active');
      i.querySelector('.bp-accordion-header')?.setAttribute('aria-expanded','false');
    });
    item.classList.add('bp-active');
    header.setAttribute('aria-expanded','true');

    if (header.id === 'naehrwerte-hub' && typeof initializeNutritionTabs === 'function') {
      initializeNutritionTabs();
    }
    scrollToEl(header);
    return true;
  }

  function clickTab(tabId){
    const btn = document.querySelector(`.bp-tab-btn[data-tab="${tabId}"]`);
    if (btn){ btn.click(); }
  }

  // --- Persistenz ---
  function saveState(){
    const openHeader = document.querySelector('.bp-accordion-item.bp-active .bp-accordion-header')?.id || null;
    const activeTab = document.querySelector('.bp-tab-btn.bp-active')?.dataset.tab || null;
    sessionStorage.setItem(KEY, JSON.stringify({ open: openHeader, tab: activeTab }));
  }
  function loadState(){
    try{
      const s = sessionStorage.getItem(KEY);
      if(!s) return false;
      const {open, tab} = JSON.parse(s);
      if(open) openAccordionByHeaderId(open);
      if(tab) clickTab(tab);
      return !!open || !!tab;
    }catch(e){ return false; }
  }

  // Events zum Speichern
  ACCORDION?.addEventListener('click', (e)=>{
    if(e.target.closest('.bp-accordion-header') || e.target.closest('.bp-tab-btn')) {
      // leicht verzögert speichern, damit Zustand nach DOM-Updates korrekt ist
      setTimeout(saveState, 0);
    }
  });

  // --- Deep-Link Logik ---
  function handleQueryAndHash(){
    const qs = new URLSearchParams(location.search);
    const open = qs.get('open');     // z.B. naehrwerte-hub
    const tab  = qs.get('tab');      // z.B. vitamins
    const hash = decodeURIComponent(location.hash.replace('#',''));

    let didSomething = false;
    if(open){ didSomething = openAccordionByHeaderId(open) || didSomething; }
    if(tab){ clickTab(tab); didSomething = true; }

    // Hash priorisieren (faq-… oder Sektion)
    if(hash){
      if(hash.startsWith('faq-')){
        const faqEl = document.getElementById('faq');
        if(faqEl) scrollToEl(faqEl);
        // Öffne die konkrete Frage (nutzt deinen bestehenden FAQ-Toggle)
        const target = document.getElementById(hash);
        const btn = target?.querySelector('.product-faq-unique-question');
        btn?.click();
        if(target) scrollToEl(target);
        didSomething = true;
      } else {
        const headerOpened = openAccordionByHeaderId(hash);
        const target = document.getElementById(hash);
        if(!headerOpened && target) scrollToEl(target);
        didSomething = headerOpened || !!target || didSomething;
      }
    }
    return didSomething;
  }

  // Reihenfolge: 1) Query+Hash, 2) Persistenz, 3) Default (nichts)
  if(!handleQueryAndHash()){
    loadState();
  }
});